<ng-template #selectSingleTpl let-context [ngTemplateType]="TriggerTemplateContext">
  <rt-button
    #origin="rtOverlayOrigin"
    rt-overlay-origin
    variant="tertiary"
    size="small"
    [dropdownOpened]="context.dropdownOpened"
    [style.max-width.px]="maxTriggerWidth()"
    (click)="context.toggleDropdown(origin)"
  >
    <rt-truncate>{{ selected()[0]?.value }}</rt-truncate>
  </rt-button>
</ng-template>

@if (!isReadOnly()) {
  @if (isLoaded()) {
    <rt-department-select
      [canCreate]="canCreate()"
      [suggestions]="suggestions()"
      [dropdownPositions]="dropdownPositions()"
      [listTpl]="listTpl() || (multiSelect() ? null : selectSingleTpl)"
      [selectFooterTemplate]="selectFooterTemplate()"
      [selectHeaderTemplate]="selectHeaderTemplate()"
      [selected]="selected()"
      [toggleDropdown]="toggleDropdown()"
      [hasTriggerWidth]="hasTriggerWidth()"
      [markSelected]="!multiSelect()"
      (select)="selectOrCreate($event)"
      (remove)="remove.emit($event)"
      (query)="query.set($event)"
      (goToSettings)="goToSettings.emit()"
    />
  }
} @else {
  <rt-select
    [readOnly]="isReadOnly()"
    [hasInputTrigger]="true"
    [labelOverride]="selected()[0]?.value || null"
  />
}
